import { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';

import { routes } from './const/routes';
import Landing from './pages/Landing';
import Form from './pages/Form';
import Report from './pages/Report';
import PageWrapper from './components/page-wrapper';
import Layout from './components/landing-layout';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import NotFound from './pages/NotFound';

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route
        path={routes.landingPage}
        element={
          <Layout>
            <Landing />
          </Layout>
        }
      />
      <Route
        path={routes.formPage}
        element={
          <PageWrapper>
            <Form />
          </PageWrapper>
        }
      />
      <Route
        path={routes.reportPage}
        element={
          <PageWrapper>
            <Report />
          </PageWrapper>
        }
      />
      <Route
        path={routes.privacyPolicy}
        element={
          <Layout>
            <PrivacyPolicy />
          </Layout>
        }
      />
      <Route
        path={routes.termsOfUse}
        element={
          <Layout>
            <TermsOfUse />
          </Layout>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'pageview',
        page: location.pathname,
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  }, [location]);

  return null;
};

const ErrorFallback = ({ error, resetError }) => (
  <div role="alert" style={{ padding: '20px', textAlign: 'center' }}>
    <h2>Something went wrong</h2>
    <p style={{ color: 'red' }}>{error.message}</p>
    <button onClick={resetError}>Try again</button>
  </div>
);

const AppRouter = () => {
  return (
    <BrowserRouter>
      <TrackPageView />
      <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppRouter;
